import { serializeArray } from "../../../helpers";

export const handleSubmitForm = function(signupForm: HTMLElement) {
  var submitBtn = document.getElementById("sign-up-submit-button");
  var closeBtn = document.getElementById("sign-up-close");
  var form = document.getElementById("signupform");
  var OptIns = Array.from<HTMLFormElement>(
    document.querySelectorAll("input[name=SelectedOptIns]")
  );
  var validateOptins = OptIns.some((box: HTMLFormElement) => box.checked);
  var successMessage = document.getElementById("sign-up-success-message");
  var condition = submitBtn !== null;
  var resubmit: boolean = true;
  var formHeading: HTMLElement | null = document.querySelector(
    ".newsletter-form__container h2"
  );
  var desctiptionText: HTMLElement | null = document.querySelector(
    ".newsletter-form__description"
  );

  function checkFieldValues(fields: any) {
    var val = true;
    fields.forEach((field: any) => {
      if (!field.value.length) val = false;
    });
    return val;
  }

  function updateMessage(res: any) {
    resubmit = true;

    if (
      successMessage !== null &&
      form !== null &&
      formHeading !== null &&
      desctiptionText !== null
    ) {
      successMessage.innerHTML = res;
      formHeading.innerHTML = "Thank You";
      signupForm.classList.add("success");
      desctiptionText.style.display = "none";
    }
  }

  function submissionHandler() {
    form = document.getElementById("signupform");
    var fields = serializeArray(form).slice(0, -1);
    var body = new FormData();

    OptIns = Array.from<HTMLFormElement>(
      document.querySelectorAll("input[name=SelectedOptIns]")
    );
    validateOptins = OptIns.some((box: HTMLFormElement) => box.checked);

    var formSubmit = (event: Event) => {
      event.preventDefault();

      if (resubmit && validateOptins) {
        resubmit = false;
        fetch(
          `${process.env.HOST}/tennis/newsletter/NewsletterSignup/Signup/`,
          config
        )
          .then(function(res: any) {
            return res.text();
          })
          .then(updateMessage);
      }
    };

    fields.forEach(function(field) {
      body.append(field.name, field.value);
    });

    var config: { method: string; body?: any } = {
      method: "post",
      body
    };

    if (checkFieldValues(fields) && validateOptins) {
      signupForm.onsubmit = formSubmit;
      OptIns[OptIns.length - 1].setCustomValidity("");
    } else {
      OptIns[OptIns.length - 1].setCustomValidity("Select at least one option");
    }
  }

  function closeHandler() {
    if (
      successMessage !== null &&
      form !== null &&
      formHeading !== null &&
      signupForm !== null &&
      desctiptionText !== null
    ) {
      successMessage.innerHTML = "";
      formHeading.innerHTML = "Sign Up";
      form.removeAttribute("style");
      desctiptionText.removeAttribute("style");
      if (signupForm.classList.contains("success")) {
        signupForm.classList.remove("success");
      }
    }
  }

  if (condition) {
    // reset onsubmit handler
    signupForm.addEventListener("submit", e => {
      if (!validateOptins) {
        e.preventDefault();
      }
    });

    if (closeBtn !== null && submitBtn !== null) {
      closeBtn.addEventListener("mouseup", closeHandler);
      submitBtn.removeEventListener("click", submissionHandler);
    }

    if (submitBtn !== null) {
      submitBtn.addEventListener("click", submissionHandler);
    }
  }
};
